import { ITripDataType } from "../types";
import { UPDATE_TRIP_CAR, UPDATE_TRIP_DROP, CLEAR_TRIP_POINTS, UPDATE_TRIP_PICKUP, UPDATE_SELECTED_POINT_TYPE, RESET_TRIP_POINTS } from "../store/types";

export const updateTripPickup = (pickupAddress: ITripDataType['pickup']) => (dispatch: any) => {
    dispatch({
        type: UPDATE_TRIP_PICKUP,
        payload: pickupAddress
    });
};

export const updateTripDrop = (dropAddress: ITripDataType['drop']) => (dispatch: any) => {
    dispatch({
        type: UPDATE_TRIP_DROP,
        payload: dropAddress
    });
};

export const updateTripCar = (selectedCar: ITripDataType['carType'] | null) => (dispatch: any) => {
    dispatch({
        type: UPDATE_TRIP_CAR,
        payload: selectedCar
    });
};

export const updatSelPointType = (selection: ITripDataType['selected']) => (dispatch: any) => {
    dispatch({
        type: UPDATE_SELECTED_POINT_TYPE,
        payload: selection
    });
};

export const clearTripPoints = () => (dispatch: any) => {
    dispatch({
        type: CLEAR_TRIP_POINTS,
        payload: null
    });
};

export const resetTripPoints = () => (dispatch: any) => {
    dispatch({
        type: RESET_TRIP_POINTS,
        payload: null
    });
};





